import React, { useRef, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { get } from 'lodash';
import './sccs/FormInputArchivoReducido.scss';
import down from '../../../../img/icons/Delta/down.png';
import Delete from '../../../../img/icons/svg/botones/delete.png';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import JSZip from 'jszip';
import { Button, Modal } from 'react-bootstrap';
import ICON_URL from '../../../../../src/img/icons/svg/botones/upload_icon.svg'
import Dowload_Icon from '../../../../img/icons/svg/download-icon.svg';
import useGetBlobs from '@/services/utils/useGetBlobs';
interface IInputProps {
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: string;
  xl?: number;
  md?: number;
  invisible?: boolean;
  setTotalSize?: (sizeDelta: number) => void;
  urlArchivo?: string;
  urlPlantilla?: string;
  nombrePortal: string;
  nota?: string
}

const allowedExtensions = [
  '.jpg', '.jpeg', '.png', '.gif', '.pdf', '.docx', '.doc',
  '.xlsx', '.xls', '.pptx', '.ppt', '.zip', '.7z', '.txt',
  '.csv', '.odt', '.ods', '.webp'
];

const padTwoDigits = (value: number): string => `${value}`.padStart(2, '0');

const getRenamedFileName = (originalName: string, attempt = 0): string => {
  const dotIndex = originalName.lastIndexOf('.');
  const hasExtension = dotIndex > 0;
  const baseName = hasExtension ? originalName.slice(0, dotIndex) : originalName;
  const extension = hasExtension ? originalName.slice(dotIndex) : '';

  const now = new Date();
  const datePart = `${padTwoDigits(now.getDate())}${padTwoDigits(now.getMonth() + 1)}${now.getFullYear()}`;
  const timePart = `h${padTwoDigits(now.getHours())}${padTwoDigits(now.getMinutes())}s${padTwoDigits(now.getSeconds())}`;
  const attemptSuffix = attempt > 0 ? `_${attempt}` : '';

  return `${baseName}_${datePart}_${timePart}${attemptSuffix}${extension}`;
};


export const reducedcreateZipFile = async (files: File[]): Promise<string> => {

  const zip = new JSZip();

  for (const file of files) {
    const base64 = await reducedFileToBase64(file);
    if (base64) {
      zip.file(file.name, base64, { base64: true });
    } else {
      // console.error(El archivo ${ file.name } está vacío o no se pudo leer.);
    }
  }

  const zipContent = await zip.generateAsync({ type: "base64" });
  return zipContent;
};


export const reducedFileToBase64 = async (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        const result = reader.result as string;
        const base64Data = result.split(',')[1];
        resolve(base64Data && base64Data);
      } else {

        resolve(null);
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

const FormInputArchivoReducido: React.FC<IInputProps> = ({
  name,
  label,
  disabled = false,
  required,
  xl = 12,
  md = 12,
  invisible,
  setTotalSize,
  urlArchivo,
  urlPlantilla,
  nombrePortal,
  nota
}) => {
  const {
    control,
    formState: { errors },
    register
  } = useFormContext();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const inputRef = useRef<HTMLInputElement>(null);
  const [showPlantillaModal, setShowPlantillaModal] = useState(false);
  const [showNotaModal, setShowNotaModal] = useState(false);
  const { handleDownloadBlob, isDownloading } = useGetBlobs();

  const downloadArchivo = () => {
    if (urlArchivo) {
      handleDownloadBlob(urlArchivo, nombrePortal);
    }
  };

  const sharedDocButtonStyle: React.CSSProperties = {
    minWidth: '52px',
    height: '36px',
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const sharedDocIconStyle: React.CSSProperties = {
    fontSize: '18px',
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div
      className={`mb-4 col-xl-${xl} col-md-${md} ${invisible ? 'd-none' : ''}`}
      data-input-name={name}
    >
      <div className="name-and-document-container">
        <label className="input-block__label mb-0">
          {label}
        </label>
        {nota &&
          <TooltipComponent content="Especificaciones sobre el Documento" onClick={() => setShowNotaModal(true)}>

            <div className="information-icon-orange p-0 icon-nota" />

          </TooltipComponent>
        }
      </div>

      {/* MODAL PLANTILLA */}
      <Modal show={showPlantillaModal} onHide={() => setShowPlantillaModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Plantilla de documento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>El documento que va a descargar es una plantilla que debe rellenar y adjuntar para cumplimentar este apartado</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPlantillaModal(false)}>
            Cerrar
          </Button>
          <Button
            as="a"
            href={urlPlantilla || '#'}
            target="_blank"
            rel="noreferrer"

            disabled={!urlPlantilla}
          >
            Descargar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL NOTA */}
      <Modal show={showNotaModal} onHide={() => setShowNotaModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Información sobre el documento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{nota}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowNotaModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Controller
        control={control}
        name={name}
        defaultValue={[]}
        rules={{
          required: required || false,
          validate: {
            validExtensions: (files: File[]) => {
              const disallowed = new Set<string>();
              (files || []).forEach((file) => {
                const ext = file.name
                  .slice(file.name.lastIndexOf('.'))
                  .toLowerCase();
                if (!allowedExtensions.includes(ext)) {
                  disallowed.add(ext);
                }
              });
              if (disallowed.size > 0) {
                const extList = Array.from(disallowed).join(', ');
                return `Algunos archivos con ${extList} no están permitidos.`;
              }
              return true;
            },
          },
        }}
        render={({ field: { value = [], onChange } }) => {
          const files: File[] = Array.isArray(value) ? value : [];

          const addFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (!e.target.files) return;
            const incoming = Array.from(e.target.files);
            const normalizeFileName = (fileName: string) => fileName.trim().toLowerCase();
            const existingNames = new Set(files.map((file) => normalizeFileName(file.name)));

            const renamedIncoming = incoming.map((file) => {
              let targetName = file.name;

              if (existingNames.has(normalizeFileName(targetName))) {
                targetName = getRenamedFileName(file.name);
                let attempt = 1;

                while (existingNames.has(normalizeFileName(targetName))) {
                  targetName = getRenamedFileName(file.name, attempt);
                  attempt += 1;
                }
              }

              existingNames.add(normalizeFileName(targetName));

              if (targetName === file.name) {
                return file;
              }

              return new File([file], targetName, {
                type: file.type,
                lastModified: file.lastModified,
              });
            });

            const addedSize = renamedIncoming.reduce(
              (sum, f) => sum + f.size / (1024 * 1024),
              0
            );

            if (typeof setTotalSize === 'function') {
              setTotalSize(addedSize);
            }

            const merged = [...files, ...renamedIncoming];
            onChange(merged);
            if (inputRef.current) inputRef.current.value = '';
          };

          const removeFileAt = (index: number) => {
            const fileToRemove = files[index];
            const removedSize = fileToRemove.size / (1024 * 1024);
            if (typeof setTotalSize === 'function') {
              setTotalSize(-removedSize);
            }
            const updated = files.filter((_, i) => i !== index);
            onChange(updated);
          };

          return (
            <>

              <div className='row'>
                {(urlArchivo || urlPlantilla) ? (
                  <div className='col-auto pe-0 d-flex align-items-center gap-2'>
                    {urlArchivo && (
                      <TooltipComponent content="Archivo adjunto">
                        <button
                          className='btn-dowload btn-dowload--archivo'
                          type="button"
                          style={sharedDocButtonStyle}
                          onClick={downloadArchivo}
                          disabled={isDownloading(urlArchivo)}
                          aria-label="Descargar archivo adjunto"
                        >
                          <img
                            src={Dowload_Icon}
                            alt=""
                            className="icon-upload"
                          />
                        </button>
                      </TooltipComponent>
                    )}

                    {urlPlantilla && (
                      <TooltipComponent content="Plantilla del documento" onClick={() => setShowPlantillaModal(true)}>
                        <button
                          className='btn-dowload btn-dowload--plantilla'
                          type="button"
                          onClick={() => setShowPlantillaModal(true)}
                          style={sharedDocButtonStyle}
                        >
                          <span className="e-icons e-file" style={sharedDocIconStyle} aria-hidden="true" />
                        </button>
                      </TooltipComponent>
                    )}
                  </div>
                ) : null}

                <div className={(urlArchivo || urlPlantilla) ? 'col' : 'col-xl-12 col-12'}>
                  <input type="hidden" {...register(`${name}.Ids.Id`)} />
                  <input type="hidden" {...register(`${name}.Ids.ExternalId`, {
                    setValueAs: v => v === "" ? 0 : v
                  })} />
                  <div
                    onClick={() => inputRef.current?.click()}
                    className="container btn-upload d-flex align-items-center justify-content-center"
                  >
                    <span className="mx-auto">
                      {files.length > 0
                        ? `Archivos adjuntos: ${files.length}`
                        : 'Adjunte un archivo'}
                    </span>
                    <img src={ICON_URL} alt="Subir" className="icon-upload" />
                  </div>
                </div>

              </div>
              <input
                type="file"
                id={name}
                multiple
                accept=".jpg,.jpeg,.png,.gif,.pdf,.docx,.doc,.xlsx,.xls,.pptx,.ppt,.zip,.7z,.txt,.csv,.odt,.ods,.webp"
                disabled={disabled}
                className={`form-control${errorMessage ? ' is-invalid' : ''}`}
                onChange={addFiles}
                ref={inputRef}
                hidden
              />


              {errorMessage && <p className="error m-0">{errorMessage}</p>}

              {files.length > 0 && (
                <details className="mt-2 container">
                  <summary className="list-files w-100 text-start">
                    <span className="p-2">Archivos adjuntados</span>
                    <img src={down} alt="" aria-hidden="true" className="iconDesplegable" />
                  </summary>

                  <ul className="list-group">
                    {files.map((file, idx) => {
                      const sizeText =
                        file.size < 1024 * 1024
                          ? `${(file.size / 1024).toFixed(2)} KB`
                          : `${(file.size / (1024 * 1024)).toFixed(2)} MB`;

                      return (
                        <li
                          key={`${file.name}-${file.size}`}
                          className="list-group-item d-flex justify-content-between align-items-center file-item"
                        >
                          <div className="file-info">
                            <span className="file-name">
                              <i className="bi bi-file-earmark me-2" />
                              {file.name}
                            </span>
                            <div className="file-size-dropdown">
                              Peso del Archivo: {sizeText}
                            </div>
                          </div>
                          <button
                            type="button"
                            className="remove-file-btn me-2"
                            aria-label={`Eliminar archivo ${file.name}`}
                            onClick={() => removeFileAt(idx)}
                          >
                            <img src={Delete} alt="" aria-hidden="true" style={{ width: 18, height: 18 }} />
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </details>
              )}
            </>
          );
        }}
      />
    </div>
  );
};

export default FormInputArchivoReducido;
